<template>
  <div class="booking">
    <router-view></router-view>
  </div>
</template>

<script>
// import {
//   Menu,
//   MenuItem,
// } from 'iview';
import { isLogin } from '@/service/api/user';

export default {
  beforeRouteEnter(to, from, next) {
    if (to.path !== '/booking/menu/default') {
      isLogin()
        .then(() => { next(); })
        .catch(() => { next('/'); });
    } else {
      next();
    }
  },
  name: 'booking',
  // data() {
  //   return {
  //   };
  // },
  // created() {
  // },
  // methods: {
  // },
};
</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'

.booking
  @include base-wrap
  margin-bottom: 14px
</style>
